// document to pring
import { StyleSheet } from "@react-pdf/renderer";
const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        // backgroundColor: 'red'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    react_pdf: {
        width: "100% !important"
    },
    em: {
        fontStyle: 'bold'
    },

    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderColor: "grey",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableHeaderRow: {
        margin: "auto",
        flexDirection: "row",
        borderWidth: 2,
        fontWeight: 900
    },
    tableCol: {
        width: "25%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    tableCol20: {
        width: "20%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },

    categoriesTableCol: {
        width: "16%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },

    tableCell: {
        margin: "auto",
        marginTop: 5,
        fontSize: 10,
    },

    tableHeaderCell: {
        margin: "auto",
        marginTop: 5,
        fontSize: 10,
        fontWeight: 900,
    }
});

export { styles };
